import http from "../utils/http";

export default {
  entrar() {
    return http({
      method: "get",
      url: "/api/status/"
    });
  },
  sair() {
    return http({
      method: "POST",
      url: "/logout"
    });
  },
  getUnidadesPermitidas() {
    return http({
      method: "GET",
      url: "/unidadesPermitidas"
    });
  },
  selecionarUnidade(unidadeId) {
    return http({
      method: "POST",
      url: "/selecionarUnidade",
      data: { id: unidadeId }
    });
  }
};
